'use strict';

$(document).ready(function () {
    var $carousels = $('.static-carousel');
    if ($carousels.length) {
        $carousels.each(function () {
            var $container = $(this);
            var $inner = $container.find('.carousel-inner').addClass('row');
            var $prev = $container.find('.previous-slide');
            var $next = $container.find('.next-slide');
            if ($inner.length) {
                $inner.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    // autoplay: true,
                    autoplaySpeed: 2000,
                    arrows: true,
                    prevArrow: $prev,
                    nextArrow: $next,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        });
    }
});
